import PortalIdParser from 'PortalIdParser';
import { createPersonalizationSearchString } from './queryParams';
import { getFeatureGates } from '../auth/featureAccess';
export const getPersonalizationUrl = (search = '') => `/personalization/${PortalIdParser.get()}${search}`;
export const isVariantEditorUrl = url => url.includes(`${getPersonalizationUrl()}/variants/`);
export const getVariantsEditorUrl = (strategyId, {
  full = true,
  search = ''
} = {}) => full ? `${getPersonalizationUrl()}/variants/${strategyId}${search}` : `/variants/${strategyId}${search}`;
export const getVariantPreviewUrl = (strategyId, assetId, {
  full = true
} = {}) => {
  const previewUrl = `${getVariantsEditorUrl(strategyId, {
    full
  })}/preview`;
  return assetId ? `${previewUrl}?assetId=${assetId}` : previewUrl;
};
export const getPostCreateRedirectUrl = (strategyId, {
  full = true
} = {}) => {
  const search = createPersonalizationSearchString({
    fromCreate: true
  });
  return getVariantsEditorUrl(strategyId, {
    full,
    search: getFeatureGates().newNav ? search : ''
  });
};